import { FONT_CONFIGS } from '../../constants/fonts';
import { FontPreloadableAsset } from '../../types/asset/preloading.types.ts';

export class FontFaceUtil {
  private static _instance: FontFaceUtil;

  private constructor() {
    // Private constructor to enforce singleton pattern
  }

  public static get instance(): FontFaceUtil {
    if (!FontFaceUtil._instance) {
      FontFaceUtil._instance = new FontFaceUtil();
    }
    return FontFaceUtil._instance;
  }

  public getFonts(): FontPreloadableAsset[] {
    return FONT_CONFIGS;
  }
}

export const getFontFaceUtil = (): FontFaceUtil => FontFaceUtil.instance;
